import { createContext, PropsWithChildren, useContext } from "react";
import { AuthBootstrapResult, useAuthBootstrap } from "./app/AuthBootstrap";

export const AuthBootstrapContext =
  createContext<AuthBootstrapResult | null>(null);

export const AuthBootstrapProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const value = useAuthBootstrap();

  // if (!value.isSuccess) {
  //   return null; // or splash screen
  // }

  return (
    <AuthBootstrapContext.Provider value={value}>
      {children}
    </AuthBootstrapContext.Provider>
  );
};

// export const useAuthState = () => {
//   const ctx = useContext(AuthBootstrapContext);
//   if (!ctx) {
//     throw new Error('useAuthState must be used inside AuthBootstrapProvider');
//   }
//   return ctx;
// };
